var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWord = function SvgWord(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 44,
    viewBox: "0 0 40 44",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.001 2h-17.5A1.5 1.5 0 0 0 5 3.5v37.001A1.5 1.5 0 0 0 6.5 42h27a1.5 1.5 0 0 0 1.5-1.5V12.998l-7.361-2.761a1.499 1.499 0 0 1-.877-.876L24.001 2Z",
    fill: "#166AEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 2v9.5a1.5 1.5 0 0 0 1.5 1.5H35L24 2Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 2v9.5a1.5 1.5 0 0 0 1.5 1.5H35L24 2Z",
    fillOpacity: 0.35,
    fill: "#166AEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.001 31.006v1h-7v-1h7Zm5-5v1h-12v-1h12Zm0-5v1h-12v-1h12Z",
    fill: "#FFF"
  }))));
};
export default SvgWord;